module.exports = __webpack_public_path__ + "static/media/Trace3_Logo_WhiteBlue.484c3eb1.png";